import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useCallback } from 'react'
import { ArticleView } from 'types'
import { ARTICLE_VIEW_PARAM } from './types'
import { COMMENT_VIEW, RIGHT_RAIL_PARAM } from '../DocRightRail/Constants'

export const useArticleViewChange = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  return useCallback(
    (view: ArticleView) => {
      const urlSearchParams = new URLSearchParams(search)
      urlSearchParams.set(ARTICLE_VIEW_PARAM, view)

      if (view === ArticleView.Commenting) {
        urlSearchParams.set(RIGHT_RAIL_PARAM, COMMENT_VIEW)
      }

      history.push({
        pathname,
        search: urlSearchParams.toString(),
      })
    },
    [history, pathname, search],
  )
}
